// src/services/dashboardService.js
import api from './api';

export default {
  // Compteurs
  counts: () =>
    api.get('/dashboard/counts').then(r => r.data),

  // Statuts des comptes
  accountStatus: () =>
    api.get('/dashboard/account-status').then(r => r.data),

  // Volume mensuel des dépôts
  monthlyDeposits: () =>
    api.get('/dashboard/monthly-deposits').then(r => r.data)
};
